import { render, staticRenderFns } from "./ModalAddNote.vue?vue&type=template&id=c0dfd602&scoped=true&"
import script from "./ModalAddNote.vue?vue&type=script&lang=js&"
export * from "./ModalAddNote.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNote.vue?vue&type=style&index=0&id=c0dfd602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dfd602",
  null
  
)

export default component.exports